import { Outlet } from 'react-router-dom'
import { useTenantGuard } from '../../hooks/useTenantGuard'

const TenantProtectedRoute = () => {
  const { allowed, loading } = useTenantGuard()

  if (loading) return null
  if (!allowed) return null // useTenantGuard maneja la redirección

  return <Outlet />
}

export default TenantProtectedRoute
